<template>
  <div class="breadcrumb-container">
    <span v-for="(currentNote, index) in notesInBreadcrumb" :key="currentNote.index" class="breadcrumb-note">
      <template v-if="notesInBreadcrumb.length>=maxBreadcrumbLength && index===1">
        <span class="breadcrumb-title spacer">...</span>
        <span class="mx-2">\</span>
      </template>
      <template v-else-if="notesInBreadcrumb.length-index<maxBreadcrumbLength-1 || index === 0">
        <span class="breadcrumb-title" @click="goToNote(currentNote.currentBreadcrumb)">
          <i class="fas fa-fw fa-home mr-1 root" v-if="currentNote.id === rootNote.id"></i>
          <span>{{currentNote.title}}</span>
          <span class="mx-2">\</span>
        </span>
      </template>
    </span>
  </div>
</template>
<script>
import goToNote from '@/mixins/go-to-note'

export default {
  props: ['note'],
  mixins: [goToNote],
  data() {
    return {
      updatedTitle: this.note.title,
      maxBreadcrumbLength: 4
    }
  },
  computed: {
    breadcrumb() {
      return this.$store.getters.breadcrumb
    },
    rootNote() {
      return this.$store.getters.rootNote
    },
    notesInBreadcrumb() {
      return this.breadcrumb.slice(0, -1).map((noteId, index) => {
        const currentBreadcrumb = this.breadcrumb.slice(0, index + 1)
        const { id, title } = this.$store.getters.getNoteById(noteId)
        return {
          id,
          title,
          currentBreadcrumb
        }
      })
    }
  },
  watch: {
    note() {
      this.updatedTitle = this.note.title
    },
    updatedTitle() {
      if (this.updatedTitle !== this.title) {
        this.$emit('update', this.updatedTitle)
      }
    }
  }
}
</script>
<style scoped lang="scss">
@import "~bootstrap/scss/_functions";
@import "~bootstrap/scss/_variables";
.breadcrumb-container {
  font-size: 0.8rem;
  color: $gray-500;
  // min-height: $line-height-base * 1em;
}
.breadcrumb-title {
  cursor: pointer;
}
[contenteditable]:focus {
  outline: 0px solid transparent;
}
.breadcrumb-title.spacer {
  cursor: default;
}
.root:not(.disabled) {
  cursor: pointer;
}
.fa-home {
  color: $gray-300;
}
</style>
